export default "__VITE_ASSET__fqAtFiD0__"